import SectionFeatures from './SectionFeatures';
export default SectionFeatures;